/**
 * The door to the `mail-privacy` chunk: the access window's "what Prest0n may see in email" section (asset graph G4b,
 * docs/PLAN-asset-graph-20261011.md G-B). The Integrations page rides the first download, so the section, its hook,
 * its words and the rule vocabulary are fetched only when a mail app's access window opens, never by a visitor who
 * does not open one. It holds nothing but the one dynamic import; the download is loaded here and nowhere else
 * (scripts/check-chat-first-paint.mjs, R4).
 */
import { createOnDemandModule } from '../../../utils/onDemandModule';
// A TYPE-only import: erased at build, never an edge into the chunk.
import type * as MailPrivacySectionNamespace from '../MailPrivacySection';

export type MailPrivacySectionModule = typeof MailPrivacySectionNamespace;

const section = createOnDemandModule<MailPrivacySectionModule>(
  () => import(/* webpackChunkName: "mail-privacy" */ '../MailPrivacySection'),
);

/** The section once it has arrived, or null. `wanted`: a mail app's access window is open, so fetch now. */
export function useMailPrivacySection(wanted: boolean): MailPrivacySectionModule | null {
  return section.useModule(wanted, wanted);
}

/** Tests only: forget the download. */
export const resetMailPrivacySectionForTests = section.resetForTests;
